import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
};

// our slice
const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccessErrorCode: (state, { payload }) => {
      state.errorCode = payload;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
  },
});
// export the actions
export const { setLoading, setError,setSuccessErrorCode, setSuccess, reset } =
  resetPasswordSlice.actions;

export const resetPasswordSelector = (state) => state.resetPassword;

// export the default reducer
export default resetPasswordSlice.reducer;

// reset password
export const resetPassword = (username, newpassword,lang,data) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let requestData = {
      UserName: username,
      NewPassword: newpassword,
      IsPageLoad: false
    };

    let { data: response } = await http.post(
      "/User/ResetPassword?LANG=" + lang + "&data=" +data,
      requestData
    );

    if (response.responseCode == 0) {
      dispatch(setSuccess());
    } else {
      if (response.responseCode == -2) {
        dispatch(setError('-2'));
      }
      else {
        dispatch(setError(response.responseDescription));
      }
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};



